import React from "react";
import './Header.css'
import u9 from "../../images/hsa-user_login/u9.png"
import u7 from "../../images/hsa-user_login/u7.png"
import u43 from '../../images/hsa-dashboard/u43.png'
import u47 from '../../images/hsa-dashboard/u47.svg'
import u48 from '../../images/hsa-dashboard/u48.png'
import u51 from '../../images/hsa-dashboard/u51.svg'
import u199 from '../../images/hsa-dashboard/u199.png'
import { Colors } from "../../design/Colors";
import LinkedText from "../LinkedText/LinkedText";
import { Fonts } from "../../design/Font";

export default class Header extends React.Component{

    constructor(props){
        super(props);
        this.state={
            //modal stuff
            show_modal:false
        }
    }

    render(){
        if(this.props.authed)
        return  <div style={{display:"flex",backgroundColor:'#FFF', flexDirection:"row",borderBottom:'1px solid rgba(215,215,215,1)',height:'7.6vh', alignItems:'center'}}>
                    <div style={{display:'flex',flex:34,flexDirection:'row',justifyContent:'flex-end'}}><img style={{alignSelf:'center',maxWidth:'100%'}} alt="u9-img"  src={u9}/></div>
                    <div style={{display:'flex',flex:2,flexDirection:'row',justifyContent:'center'}}><img style={{maxWidth:'100%'}} alt="u7-img"  src={u7}/></div>
                    <div style={{display:'flex',flex:25,flexDirection:'row',justifyContent:'flex-begin'}}><span style={{textAlign:'left',fontFamily:'Helvetica', fontWeight:400, fontSize:20, color:"#666666"}}>HSA Card</span></div>
                    <div style={{display:'flex',flex:20}}/>
                    <div style={{display:'flex', backgroundColor:Colors.light_grey, justifyContent:"center", alignItems:'center', position:'relative', width:'1%', padding:"0.4%", borderRadius:"100%"}}>
                        <img src={u51} alt='u51'></img>
                    </div>
                    <div style={{display:'flex',flex:1.5}}/>
                    <div style={{display:'flex', backgroundColor:Colors.light_grey, justifyContent:"center", alignItems:'center', position:'relative', width:'1%', padding:"0.4%", borderRadius:"100%"}}>
                        <img style={{}} src={u47} alt='u47'></img> 
                        <img style={{position:'absolute',top:0,right:0}} src={u48} alt='u48'></img>
                    </div>
                    <div style={{display:'flex',flex:5}}/>
                    <div style={{display:'flex',flexDirection:'column',}}>
                        <span style={{fontSize:14, color:"#1E1E1E",textAlign:'right'}}>John Doe</span>
                        <span style={{fontSize:11, color:'#999999',textAlign:'right'}}>Administrator</span>
                    </div>
                    <div style={{display:'flex',flex:1}}/>    
                    <div onClick={()=>{this.setState({show_modal:!this.state.show_modal})}} style={{display:'flex', justifyContent: 'center', alignItems: 'center', height:'4vh', cursor:'pointer'}}>
                        <img style={{height:'5vh',}} src={u199} alt='u199'></img>
                    </div>
                    <div style={{display:'flex',flex:1}}/>

                    <div style={{dispaly:'flex',flex:1}}>
                        <img src={u43} alt='u43' style={{height:"9%"}}></img>
                    </div>
                    <div style={{display:'flex',flexDirection:'row',flex:24}}/>
                    {this.state.show_modal?
                        <div style={{display:'flex',flexDirection:'column',position:'absolute',height:'15vh',width:'6.7vw',border:'1px solid rgba(215,215,215,1)',backgroundColor:'#FFF', borderRadius:5,marginTop:'26.5vh',marginLeft:'71.5vw',paddingTop:'2vh',paddingLeft:'0.5vw',paddingRight:'1vw',paddingBottom:'2.5vh',}}>
                        <span style={{...Fonts.text,color:Colors.dark_grey, marginBottom:'1.9vh', cursor:'pointer'}}>Profile</span>
                        <span style={{...Fonts.text,color:Colors.dark_grey, marginBottom:'1.9vh', cursor:'pointer'}}>My Account</span>
                        <span style={{...Fonts.text,color:Colors.dark_grey, marginBottom:'1.9vh', cursor:'pointer'}}>Preferences</span>
                        <div style={{display:'flex',backgroundColor:Colors.grey,height:1,marginTop:'1vh',marginBottom:'1vh'}}/>{/**divider */}
                        <LinkedText onClick={()=>{this.props.navigator('/Login');}} title='Log Out'/>
                    </div>
                    :null}{/**logout modal */}
                </div>
        else
        return  <div style={{display:"flex",backgroundColor:'#FFF', flex:1, flexDirection:"row",borderBottom:'1px solid rgba(215,215,215,1)',height:'5vh'}}>
                    <div style={{display:'flex',flex:21,flexDirection:'row',justifyContent:'flex-end'}}><img style={{alignSelf:'center',maxWidth:'100%'}} alt="u9-img"  src={u9}/></div>
                    <div style={{display:'flex',flex:1,flexDirection:'row',justifyContent:'center'}}><img style={{alignSelf:'center',maxWidth:'100%'}} alt="u7-img"  src={u7}/></div>
                    <div style={{display:'flex',flex:25,flexDirection:'row',justifyContent:'flex-begin'}}><span style={{alignSelf:'center',textAlign:'left',fontFamily:'Helvetica', fontWeight:400, fontSize:20}}>HSA Card</span></div>
                    <div style={{display:'flex',flex:28,flexDirection:'row',justifyContent:'center',}}><span style={{alignSelf:'center',textAlign:'left',fontFamily:'Helvetica', fontWeight:400, fontSize:14}}>Sign In</span></div>
                    <div style={{display:'flex',flexDirection:'row',flex:2}}/>
                </div>
    }
}